module.exports = __webpack_public_path__ + "img/49.22a33cb7.jpg";